import { render, staticRenderFns } from "./guanggaozhanghu.vue?vue&type=template&id=fcc5b984&scoped=true&"
import script from "./guanggaozhanghu.vue?vue&type=script&lang=js&"
export * from "./guanggaozhanghu.vue?vue&type=script&lang=js&"
import style0 from "./guanggaozhanghu.vue?vue&type=style&index=0&id=fcc5b984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc5b984",
  null
  
)

export default component.exports